import { render, staticRenderFns } from "./PersonCardHeader.vue?vue&type=template&id=6ac27026&scoped=true&"
import script from "./PersonCardHeader.vue?vue&type=script&lang=js&"
export * from "./PersonCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonCardHeader.vue?vue&type=style&index=0&id=6ac27026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac27026",
  null
  
)

export default component.exports